<div class="newField-radio-button-config">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config [device]="device" [elementChoosing]="objectChoosing"
      [width]="class[objectChoosing.resize_field]['width']" [height]="class[objectChoosing.resize_field]['height']">
    </app-width-height-config>

    <ul nz-menu nzMode="inline">
      <!-- CHỌN THÔNG SỐ -->
      <li nz-submenu nzTitle="{{'chon_thong_so' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <mat-form-field *ngIf="staticdata.id_main_sector == 'snimei'" appearance="fill">
          <mat-label>{{'nhom_tra_cuu' | translate}}</mat-label>
          <mat-select [(ngModel)]="staticdata.lookup_group" (ngModelChange)="changeLookupGroup($event)">
            <mat-option *ngFor="let item of lookupGroupArray" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field style="width: 100%">
          <mat-label>{{'thong_so_san_pham' | translate}}</mat-label>
          <mat-select [(ngModel)]="staticdata.field_custom" (ngModelChange)="onChangeFieldCustom($event)"
            [disabled]="newFields.length == 0">
            <mat-option *ngFor="let item of newFields" [value]="item.field_custom">{{item?.field_lable ??
              item.field_custom}}</mat-option>
          </mat-select>
        </mat-form-field>
        <p class="line-normal" style="color: rgb(212, 78, 78);">
          {{
          'vui_long_vao_trang_admin_truong_du_lieu_tu_tao_tao_du_lieu_sau_do_quay_lai_day_chon_truong_du_lieu' |
          translate
          }}
        </p>
      </li>
      <!-- CẤU HÌNH GIAO DIỆN -->
      <li nz-submenu nzTitle="{{'giao_dien'| translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <nz-radio-group [(ngModel)]="config.radio_type" (ngModelChange)="onRadioChange()">
          <label *ngFor="let tab of tabs; let i = index" nz-radio [nzValue]="i">{{tab}}</label>
        </nz-radio-group>
      </li>

      <!-- Kiểu thiết kế -->
      <li nz-submenu nzTitle="{{'thiet_ke_cac_gia_tri' | translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
          <p class="m-0 title" style="line-height: 1.5;">Kích thước các giá trị</p>
          <nz-radio-group [(ngModel)]="config['radio-item_type']" (ngModelChange)="onRadioItemChange()">
            <label nz-radio [nzValue]="1">Đồng đều</label>
            <label nz-radio [nzValue]="2">Theo nội dung</label>
          </nz-radio-group>
          <ng-container *ngIf="config['radio-item_type'] == 2">
            <app-padding-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classPadding]="class['radio-more__items--content']"
              [paddingConfigs]="[
                { type: 'top' },
                { type: 'bottom' },
                { type: 'left' },
                { type: 'right' }
              ]">
            </app-padding-config>
          </ng-container>

          <div class="position">
            <p class="m-0 title" style="line-height: 1.5;">{{'vi_tri'| translate}}</p>
            <div class="position-unit">
              <p class="title" style="font-weight: 500;">{{'huong' | translate}}</p>
              <nz-radio-group class="position-option" [(ngModel)]="class['radio__container']['flex-direction']"
                (ngModelChange)="updateObject()">
                <label nz-radio nzValue="row"><span>{{'ngang' | translate}}</span></label>
                <label nz-radio nzValue="column"><span>{{'doc' | translate}}</span></label>
              </nz-radio-group>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3">
              <p class="title" style="font-weight: 500;">{{'xuong_dong' | translate}}</p>
              <nz-switch class="ml-3" [ngModel]="class['radio__container']['flex-wrap'] == 'wrap'"
                (ngModelChange)="class['radio__container']['flex-wrap'] = $event ? 'wrap' : 'nowrap'; updateObject()">
              </nz-switch>
            </div>
            <div class="position-unit"
              style="display: flex;align-items: center;justify-content: space-between;margin-top: 10px;">
              <p class="m-0 title" style="line-height: 1.5;">{{'khoang_cach_giua_cac_don_vi' | translate}}</p>
              <nz-input-number [ngModel]="class['radio__container']['gap'] | vhnumber "
                (ngModelChange)="class['radio__container']['gap']= $event + 'px'" (nzBlur)="updateObject()"></nz-input-number>
            </div>
            <nz-slider [ngModel]="class['radio__container']['gap'] | vhnumber "
              (ngModelChange)="class['radio__container']['gap']= $event + 'px'" (nzOnAfterChange)="updateObject()"></nz-slider>
          </div>
      </li>

      <ng-container *ngIf="config.radio_type != 3">
        <div class="item"
          style="display: flex; justify-content: space-between; gap: 5px; align-items: center; line-height: normal;">
          <p>{{ 'thiet_ke_nut_khi' | translate }}:&nbsp;{{ (!objectChoosing.isActive ? 'chua_kich_hoat' : 'kich_hoat') |
            translate}}</p>
          <nz-switch class="ml-3" [(ngModel)]="objectChoosing.isActive"></nz-switch>
        </div>
      </ng-container>

      <!-- CẤU HÌNH CỦA KIỂU 1 -->
      <ng-container *ngIf="config.radio_type == 0">
        <!-- CẤU HÌNH {{'chu_va_mau_nen'| translate}}-->
        <li nz-submenu nzTitle="{{'chu_va_mau_nen'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-family']"
                    [(value)]="class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{'co_chu' | translate}}</mat-label>
                  <input type="number" matInput
                    [ngModel]="class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-size'] | vhnumber"
                    name="type1-font-size" (ngModelChange)="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-size'] =
                        $event + 'px'; updateObject()
                    " />
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-weight'] == 'bold'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-weight'] =
                        class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-weight'] == 'bold'
                          ? '500'
                          : 'bold';
                      updateObject()
                    ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-style'] == 'italic'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-style'] =
                        class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['font-style'] == 'normal'
                          ? 'italic'
                          : 'normal';
                      updateObject()
                    ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['text-decoration'] ==
                      'underline'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['text-decoration'] =
                        class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['text-decoration'] ==
                        'none'
                          ? 'underline'
                          : 'none';
                      updateObject()
                    ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['text-transform'] ==
                      'uppercase'
                        ? 'primary'
                        : 'default'
                    " (click)="
                      class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['text-transform'] =
                        class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content']['text-transform'] ==
                        'none'
                          ? 'uppercase'
                          : 'none';
                      updateObject()
                    ">
                  <span>AB</span>
                </button>
                <!-- Màu chữ -->
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content'].color"
                    [style.background]="class[ objectChoosing.isActive ? '+radio__items--content' :  '-radio__items--content'].color"
                    (colorPickerClose)="updateObject()" name="type1-color" [cpWidth]="'230px'"
                    [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <!-- Màu nền -->
            <div class="color-pick">
              <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class[ objectChoosing.isActive ? '+radio__items' : '-radio__items']['background-color']"
                [style.background]="class[ objectChoosing.isActive ? '+radio__items' : '-radio__items']['background-color']"
                (colorPickerClose)="updateObject()" name="type1-background-color" [cpWidth]="'230px'" />
            </div>
          </div>
        </li>
        <!-- CẤU HÌNH ĐỊNH DẠNG VIỀN -->
        <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
    
          <app-borders-config [device]="device" [class]="class"
            [borderClass]="class[ objectChoosing.isActive ? '+radio__items' : '-radio__items']"
            [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
          </app-borders-config>
    
    
          <!-- Nút mở rộng -->
          <div class="item-border my-3" style="float: right;">
            <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </li>
      </ng-container>
      <!-- CẤU HÌNH CỦA KIỂU 1 -->
      
      <!-- CÂU HÌNH CỦA KIỂU 2 -->
      <ng-container *ngIf="config.radio_type == 1">
        <!-- CẤU HÌNH {{'chu_va_mau_nen'| translate}}-->
        <li nz-submenu nzTitle="{{'chu_va_mau_nen'| translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-family']"
                    [(value)]="class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{'co_chu' | translate}} </mat-label>
        
                  <input type="number" matInput
                    [ngModel]="class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-size'] | vhnumber"
                    (ngModelChange)="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-size'] =
                          $event + 'px'; updateObject()
                      " />
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-weight'] == 'bold'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-weight'] =
                          class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-weight'] == 'bold'
                            ? '500'
                            : 'bold';
                        updateObject()
                      ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-style'] =
                          class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['font-style'] == 'normal'
                            ? 'italic'
                            : 'normal';
                        updateObject()
                      ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['text-decoration'] ==
                        'underline'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['text-decoration'] =
                          class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['text-decoration'] ==
                          'none'
                            ? 'underline'
                            : 'none';
                        updateObject()
                      ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['text-transform'] ==
                        'uppercase'
                          ? 'primary'
                          : 'default'
                      " (click)="
                        class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['text-transform'] =
                          class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content']['text-transform'] ==
                          'none'
                            ? 'uppercase'
                            : 'none';
                        updateObject()
                      ">
                  <span>AB</span>
                </button>
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content'].color"
                    [style.background]="class[ objectChoosing.isActive ? '+radio-radio__items--content' : '-radio-radio__items--content'].color"
                    (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <div class="field-row-text">
              <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class[objectChoosing.isActive ? '+radio-radio__items' : '-radio-radio__items']['background-color']"
                  [style.background]="class[objectChoosing.isActive ? '+radio-radio__items' : '-radio-radio__items']['background-color']"
                  (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
              </div>
            </div>
        
            <div class="field-row-text" *ngIf="objectChoosing.isActive">
              <p class="m-0 title w-50">{{'mau_nut' | translate}}</p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['-radio-radio__items--input']['accent-color']"
                  [style.background]="class['-radio-radio__items--input']['accent-color']" (colorPickerClose)="updateObject()"
                  [cpWidth]="'230px'" />
              </div>
            </div>
          </div>
        </li>
        
        <!-- CẤU HÌNH ĐỊNH DẠNG VIỀN -->
        <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <app-borders-config [device]="device" [class]="class"
            [borderClass]="class[objectChoosing.isActive ? '+radio-radio__items' : '-radio-radio__items']"
            [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
          </app-borders-config>
        
          <!-- Nút mở rộng -->
          <div class="item-border my-3" style="float: right;">
            <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </li>
      </ng-container>
      <!-- CÂU HÌNH CỦA KIỂU 2 -->
      
      <!-- CẤU HÌNH CỦA KIỂU 3 -->
      <ng-container *ngIf="config.radio_type == 2">
        <!-- CẤU HÌNH {{'chu_va_mau_nen'| translate}}-->
        <li nz-submenu nzTitle="{{'chu_va_mau_nen'| translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-family']"
                    [(value)]="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{'co_chu' | translate}} </mat-label>
                  <input type="number" matInput
                    [ngModel]="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-size'] | vhnumber"
                    (ngModelChange)="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-size'] = $event + 'px'; updateObject()"
                    [value]="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-size'] | vhnumber">
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                  (click)="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-weight'] =
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-weight'] == 'bold' ? '500' : 'bold';
                  updateObject()
                ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-style'] == 'italic' ? 'primary' : 'default'" 
                  (click)="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-style'] =
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['font-style'] == 'normal' ? 'italic' : 'normal';
                  updateObject()
                ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['text-decoration'] == 'underline' ? 'primary' : 'default'" 
                  (click)="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['text-decoration'] =
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['text-decoration'] == 'none' ? 'underline' : 'none';
                  updateObject()
                ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['text-transform'] == 'uppercase' ? 'primary' : 'default'" (click)="
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['text-transform'] =
                  class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content']['text-transform'] == 'none' ? 'uppercase' : 'none';
                  updateObject()
                ">
                  <span>AB</span>
                </button>
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content'].color"
                    [style.background]="class[ objectChoosing.isActive ? '+radio-check__items--content' : '-radio-check__items--content'].color"
                    (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <div class="field-row-text">
              <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
        
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class[ objectChoosing.isActive ? '+radio-check__items' : '-radio-check__items']['background-color']"
                [style.background]="class[ objectChoosing.isActive ? '+radio-check__items' : '-radio-check__items']['background-color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
            </div>
            <!-- Màu dấu check -->
            <div class="field-row-text" *ngIf="objectChoosing.isActive">
              <p class="m-0 title w-50" style="line-height: normal;">{{'mau_dau_check' | translate}}</p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['+radio-check__items--after']['color']"
                  [style.background]="class['+radio-check__items--after']['color']" (colorPickerClose)="updateClass()"
                  [cpWidth]="'230px'" />
              </div>
            </div>
        
            <!-- Màu nền check -->
            <div class="field-row-text" *ngIf="objectChoosing.isActive">
              <p class="m-0 title w-50" style="line-height: normal;">{{'mau_nen_dau_check' | translate}} </p>
              <div>
                <input class="input-color " type="button" [cpOKButton]="true"
                  [(colorPicker)]="class['+radio-check__items--before']['border-top-color']"
                  [style.background]="class['+radio-check__items--before']['border-top-color']"
                  (colorPickerChange)="updateBorderColor()"
                  (colorPickerClose)="updateClass();" [cpWidth]="'230px'" />
              </div>
            </div>
        
          </div>
        </li>
        <!-- CẤU HÌNH ĐỊNH DẠNG VIỀN -->
        <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <app-borders-config [device]="device" [class]="class" [elementChoosing]="objectChoosing"
            [borderClass]="class[ objectChoosing.isActive ? '+radio-check__items' : '-radio-check__items']"
            [id_object]="objectChoosing._id">
          </app-borders-config>
          <!-- Nút mở rộng -->
          <div class="item-border my-3" style="float: right;">
            <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[2])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </li>
      </ng-container>
      <!-- CẤU HÌNH CỦA KIỂU 3 -->

      <!-- CẤU HÌNH CỦA KIỂU 4 -->
      <ng-container *ngIf="config.radio_type == 3">
        <!-- CẤU HÌNH {{'chu_va_mau_nen'| translate}}-->
        <li nz-submenu nzTitle="{{'chu_va_mau_nen'| translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class['radio-more__items--content']['font-family']"
                    [(value)]="class['radio-more__items--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>{{'co_chu' | translate}} </mat-label>
                  <input type="number" matInput
                    [ngModel]="class['radio-more__items--content']['font-size'] | vhnumber"
                    (ngModelChange)="class['radio-more__items--content']['font-size'] = $event + 'px'; updateObject()"
                    [value]="class['radio-more__items--content']['font-size'] | vhnumber">
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                  class['radio-more__items--content']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                  (click)="class['radio-more__items--content']['font-weight'] = class['radio-more__items--content']['font-weight'] == 'bold' ? '500' : 'bold';
                  updateObject()
                ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                  class['radio-more__items--content']['font-style'] == 'italic' ? 'primary' : 'default'" 
                  (click)="class['radio-more__items--content']['font-style'] = class['radio-more__items--content']['font-style'] == 'normal' ? 'italic' : 'normal';
                  updateObject()
                ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                  class['radio-more__items--content']['text-decoration'] == 'underline' ? 'primary' : 'default'" 
                  (click)="class['radio-more__items--content']['text-decoration'] = class['radio-more__items--content']['text-decoration'] == 'none' ? 'underline' : 'none';
                  updateObject()
                ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                  class['radio-more__items--content']['text-transform'] == 'uppercase' ? 'primary' : 'default'" 
                  (click)="class['radio-more__items--content']['text-transform'] = class['radio-more__items--content']['text-transform'] == 'none' ? 'uppercase' : 'none';
                  updateObject()
                ">
                  <span>AB</span>
                </button>
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class['radio-more__items--content'].color"
                    [style.background]="class['radio-more__items--content'].color"
                    (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <div class="field-row-text">
              <p class="m-0 title w-50">{{'mau_nen' | translate}} </p>
        
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['radio-more__items']['background-color']"
                [style.background]="class['radio-more__items']['background-color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
            </div>
          </div>
        </li>

        <!-- <li nz-submenu nzTitle="{{'chu_va_mau_nen_so_luong'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
          <div class="contains-text">
            <div class="field-row-text">
              <div class="text-family" style="width: 70%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Font</mat-label>
                  <mat-select
                    [(ngModel)]="class['radio-more__quantity--content']['font-family']"
                    [(value)]="class['radio-more__quantity--content']['font-family']"
                    (ngModelChange)="updateObject()">
                    <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="text-size" style="width: 30%;">
                <mat-form-field style="width: 100%;">
                  <mat-label>Cỡ chữ </mat-label>
                  <input type="number" matInput
                    [ngModel]="class['radio-more__quantity--content']['font-size'] | vhnumber"
                    (ngModelChange)="class['radio-more__quantity--content']['font-size'] = $event + 'px'; updateObject()"
                    [value]="class['radio-more__quantity--content']['font-size'] | vhnumber">
                </mat-form-field>
              </div>
            </div>
            <div class="config-font">
              <p class="title-font">{{'kieu_chu' | translate}}</p>
              <div class="field-row">
                <button class="font-text-btn font-text-btn-bold" title="bold" nz-button [nzType]="
                  class['radio-more__quantity--content']['font-weight'] == 'bold' ? 'primary' : 'default'" 
                  (click)="class['radio-more__quantity--content']['font-weight'] = class['radio-more__quantity--content']['font-weight'] == 'bold' ? '500' : 'bold';
                  updateObject()
                ">
                  <span style="font-weight: 600">B</span>
                </button>
                <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                  class['radio-more__quantity--content']['font-style'] == 'italic' ? 'primary' : 'default'" 
                  (click)="class['radio-more__quantity--content']['font-style'] = class['radio-more__quantity--content']['font-style'] == 'normal' ? 'italic' : 'normal';
                  updateObject()
                ">
                  <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                  class['radio-more__quantity--content']['text-decoration'] == 'underline' ? 'primary' : 'default'" 
                  (click)="class['radio-more__quantity--content']['text-decoration'] = class['radio-more__quantity--content']['text-decoration'] == 'none' ? 'underline' : 'none';
                  updateObject()
                ">
                  <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                </button>
                <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                  class['radio-more__quantity--content']['text-transform'] == 'uppercase' ? 'primary' : 'default'" 
                  (click)="class['radio-more__quantity--content']['text-transform'] = class['radio-more__quantity--content']['text-transform'] == 'none' ? 'uppercase' : 'none';
                  updateObject()
                ">
                  <span>AB</span>
                </button>
                <div>
                  <input id="color" type="button" [cpOKButton]="true"
                    [(colorPicker)]="class['radio-more__quantity--content'].color"
                    [style.background]="class['radio-more__quantity--content'].color"
                    (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                </div>
              </div>
            </div>
            <div class="field-row-text">
              <p class="m-0 title w-50">Màu nền </p>
        
              <input class="input-color w-50" type="button" [cpOKButton]="true"
                [(colorPicker)]="class['radio-more__quantity']['background-color']"
                [style.background]="class['radio-more__quantity']['background-color']"
                (colorPickerClose)="updateObject()" [cpWidth]="'230px'" />
            </div>
          </div>
        </li> -->
        <!-- CẤU HÌNH ĐỊNH DẠNG VIỀN -->
        <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
          <app-borders-config [device]="device" [class]="class"
            [borderClass]="class['radio-more__items']" [elementChoosing]="objectChoosing"
            [id_object]="objectChoosing._id">
          </app-borders-config>
          <!-- Nút mở rộng -->
          <div class="item-border my-3" style="float: right;">
            <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[3])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </li>

        <li nz-submenu nzTitle="{{'so_luong_hien_thi'| translate}}" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
          <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 10px;">
            <p class="m-0 title" style="line-height: 1.5;">{{'so_luong_hien_thi'| translate}}</p>
            <nz-input-number
              [(ngModel)]="config.quantity_display"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
        </li>
      </ng-container>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu2"
      (nzOpenChange)="openHandler('menu2')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="class[objectChoosing.isActive ? '+radio__items': '-radio__items']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="class[objectChoosing.isActive ? '+radio-radio__items' : '-radio-radio__items' ]"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="class[objectChoosing.isActive ? '+radio-check__items' : '-radio-check__items']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config [device]="device" [class]="class"
        [borderRadiusClass]="class['radio-more__items']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>